import { render, staticRenderFns } from "./YrForm.vue?vue&type=template&id=b9c76e88&scoped=true&lang=html&"
import script from "./YrForm.vue?vue&type=script&lang=js&"
export * from "./YrForm.vue?vue&type=script&lang=js&"
import style0 from "./YrForm.vue?vue&type=style&index=0&id=b9c76e88&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c76e88",
  null
  
)

export default component.exports